

















































import { Component, Vue } from 'vue-property-decorator'
import IntroduceList from './comps/introuduce-list.vue'
import ExperienceCard from './comps/experience-card.vue'
import CourseCard from './comps/course-card.vue'
import openApp from '@ivy/fts/openApp'
import config from '../../config'
import { getDeviceId, isIos, sendSmsCode } from '@ivy/fts/utils'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as weixin from '@ivy/fts/weixin'
import RichText from '@ivy/fts/comps/RichText.vue'

@Component({
  components: {
    IntroduceList,
    ExperienceCard,
    CourseCard,
    RichText,
  },
})
export default class VipForNewComer extends Vue {
  isHasRequire: boolean = false // 当前是否已经发起了请求
  isAlreadyget: boolean = false // 是否原来已经领取过
  showFooter: boolean = false // 是否显示底部按钮
  isOldNotAvailable: boolean = false // 老用户是否可领
  isHasAuth: boolean = false // 是否已有课程权限
  learninEnv: string // 课程时上课方式 'h5' 'app'
  isFirst: boolean = false // 是否是第一次领取
  activityId: any
  info: any
  channel: any
  type: any = '' // 会员、课程
  rule_content: any // 活动规则富文本
  head_url: any
  introduce_pic: string = ''
  bg_color: string = ''
  courseId: string = ''
  course_type: string = ''
  async mounted() {
    await env.init()
    this.info = await env.getInfo()
    let { channel, activityId } = this.$route.query
    this.channel = channel
    this.activityId = +activityId
    if (!this.activityId) return this.$Toast('活动不存在')
    await this.getActivityInfo()
    await this.addStatistics('Display_Activity')
  }
  // 获取赠送活动赠礼类型 课程 会员
  async getActivityInfo() {
    let requestConfig: any = { disableLoading: true, disableAlert: true }
    const { data: activityInfo } = await this.$axios.get(
      `/api/activity/appActivity/h5present/getRewardType?activity_id=${
        this.activityId
      }`,
      requestConfig
    )
    if (activityInfo.code) {
      return this.$Toast(activityInfo.message)
    }
    this.rule_content = activityInfo.rules1
    this.head_url = activityInfo.back_img_url1
    this.bg_color = activityInfo.bg_color
    this.introduce_pic = activityInfo.back_img_url2
    if (
      activityInfo.gift_type === '课程' ||
      activityInfo.gift_type === '专辑'
    ) {
      this.type = 'course'
      this.learninEnv = activityInfo.learn_type
    } else if (activityInfo.gift_type === '会员') {
      this.type = 'vip'
    }
    let { share_title, share_detail, share_img } = activityInfo
    await this.setShare(share_title, share_detail, share_img)
  }

  async setShare(share_title, share_detail, share_img) {
    const link = window.location.href
    let options = {
      title: share_title,
      desc: share_detail,
      imgUrl: share_img,
      link: encodeURI(link),
    }
    await weixin.weixinShare(options)
  }
  async addStatistics(event_type, p1 = this.channel, p2 = null) {
    let requestConfig: any = { disableLoading: true, disableAlert: true }
    try {
      await this.$axios.post(
        '/api/activity/appActivity/punchDistributionAc/addstatistics',
        {
          activity_id: this.activityId,
          event_type,
          p1,
          p2: p2 ? p2 : getDeviceId(),
          table: 'a_h5_activity_gift',
          ...this.info.publicParams,
        },
        requestConfig
      )
    } catch (error) {
      console.log(error)
    }
  }
  // 发送验证码
  async sendSmsCode(phoneNumber) {
    let res = await sendSmsCode(1, phoneNumber)
    this.$Toast('验证码发送成功')
  }

  // 视图状态
  leaveView(status) {
    this.showFooter = status
  }
  backToTop() {
    if (this.isHasRequire) {
      if (this.type === 'vip') {
        return openApp()
      } else {
        if (this.isOldNotAvailable || this.learninEnv === 'app') {
          return openApp()
        } else {
          return window.scrollTo(0, 0)
        }
      }
    } else {
      return window.scrollTo(0, 0)
    }
    // return this.isHasRequire ? openApp() : window.scrollTo(0, 0)
  }
  // 点击免费领取、立即学习和打开app
  async clickHandler(data) {
    if (data && data.type === 'openApp') {
      // 打开app
      await this.addStatistics('click_openApp')
      return openApp()
    }
    let { phoneNumber, smsCode, type } = data
    try {
      let { data: result } = await this.$axios.post(
        `/api/activity/appActivity/h5present/giveH5Reward`,
        {
          h5_present_id: this.activityId,
          phone: phoneNumber,
          channel: this.channel,
          sms_code: smsCode,
          mobile_prefix_id: 1,
          // @ts-ignore
        },
        { disableAlert: true }
      )
      switch (result.code) {
        case 'HAS_BE_OVERDUE': // 活动已过期
          this.$Toast(result.message)
          break
        case 'ALREADY_RECEIVED': // 已经领取过
          this.isHasRequire = true
          this.isAlreadyget = true
          if (this.type === 'course') {
            this.courseId = result.data.course_info.course_id
            this.course_type = result.data.course_info.course_type
            this.learnCourse()
          }
          break
        case 'ALREADY_AUTH': // 已经有权限
          this.isHasRequire = true
          this.isHasAuth = true
          if (this.type === 'course') {
            this.courseId = result.data.course_info.course_id
            this.course_type = result.data.course_info.course_type
            this.learnCourse()
          }
          break
        case 'NOT_SATISFIED': // 不符合领取条件
          this.isHasRequire = true
          this.isOldNotAvailable = true
          break
        case 'GOODS_NOT_EXIST': // 商品异常
          this.$Toast('商品存在异常')
          break
        default:
          if (result.code) {
            this.$Toast(result.message)
          } else {
            this.isHasRequire = true
            this.isFirst = true
            if (this.type === 'course') {
              this.courseId = result.course_info.course_id
              this.course_type = result.course_info.course_type
            }
          }
      }
    } catch (error) {
      console.log('err', error)
    }
  }
  async learnCourse() {
    if (this.learninEnv !== 'app') {
      let origin =
        config.env === 'production'
          ? 'https://m.ivydad.com'
          : 'http://m.ivydad.com.cn'
      if (this.course_type === 'knowlege') {
        window.location.href = `${origin}/knowlege/channelDetail?id=${
          this.courseId
        }`
      } else if (this.course_type === 'album') {
        window.location.href = `${origin}/wechat2/albumInfo/${
          this.courseId
        }?isWechatLogin=nologin`
      } else {
        window.location.href = `${origin}/age3?courseId=${this.courseId}`
      }
    }
  }
}
